import type { Device } from '@packages/themes/src/default';

export const getChannelFromDevice = (device: Device) => {
  if (device === 'mobile') return 'mob';
  if (device === 'tablet') return 'tab';

  return 'web';
};
